package com.essntl.features.travelagent.domain.repository

import com.essntl.features.travelagent.domain.model.TravelAgentModel

interface TravelAgentRepository {
    suspend fun getById(id: String): Result<TravelAgentModel>

    suspend fun getTravelAgentsByContacts(contactIds: List<String>): Result<List<TravelAgentModel>>

    suspend fun getAll(
        page: Long,
        limit: Int = 10,
        query: String,
    ): Result<List<TravelAgentModel>>

    suspend fun insert(travelAgent: TravelAgentModel): Result<TravelAgentModel>

    suspend fun update(travelAgent: TravelAgentModel): Result<TravelAgentModel>

    suspend fun delete(travelAgent: TravelAgentModel): Result<Unit>

    suspend fun getByPhoneNumbers(phoneNumbers: Set<String>): Result<List<TravelAgentModel>>

    suspend fun getTravelAgentsByLogo(logoId: String): Result<List<TravelAgentModel>>

    suspend fun getByContactId(contactId: String): Result<TravelAgentModel?>
}